import { Injectable, signal } from '@angular/core';

export type methodType = 'get' | 'delete' | 'patch' | 'put' | 'post';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _loading = signal(false);
  private loadingCount = 0;
  private skipNext = false;

  public readonly loading$ = this._loading.asReadonly();

  /**
   * List of requests that do not trigger the loading spinner
   */
  private skippedRequests: Record<methodType, readonly string[]> = {
    get: [],
    delete: [],
    post: [],
    patch: [],
    put: [],
  } as const;

  public isSkippedRequest(requestMethod: string, requestUrl: string) {
    const method = requestMethod.toLowerCase() as methodType;
    const skippedRequests = this.skippedRequests[method] || [];

    const found = skippedRequests.some((url: string) => requestUrl.toLowerCase().includes(url.toLowerCase()));

    return found;
  }

  public skipNextRequest(): void {
    this.skipNext = true;
  }

  public trySkipNextRequest(requestMethod: string, requestUrl: string) {
    if (this.isSkippedRequest(requestMethod, requestUrl)) {
      this.skipNextRequest();
      return true;
    }

    return false;
  }

  public show(): void {
    this.loadingCount++;
    if (!this.skipNext) {
      this._loading.set(true);
    } else {
      this.skipNext = false;
    }
  }

  public hide(): void {
    this.loadingCount--;
    if (this.loadingCount <= 0) {
      this._loading.set(false);
    }
  }
}
